export default __webpack_public_path__ + "static/donut-404-fe26a6960571c5c9bccf2f5aab33b381.mp4";